<template>
  <div
    ref="panel"
    class="systemInfo"
    :style="{ left: `${position.x}px`, top: `${position.y}px` }"
  >
    <div
      class="systemInfo-drag"
      @mousedown="startDrag"
      @touchstart.prevent="startDragTouch"
    >
      Systemhinweis
    </div>
    <div class="systemInfo-body">
      System mit<br />
      {{ this.$serverUrl().includes("/backend") ? "Produktiv" : "Entwicklungs" }}
      <br />Datenbank
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      position: {
        x: 16,
        y: 16,
      },
      dragging: false,
      dragOffset: {
        x: 0,
        y: 0,
      },
    };
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.stopDrag);
    window.removeEventListener("touchmove", this.onDragTouch);
    window.removeEventListener("touchend", this.stopDrag);
  },
  methods: {
    startDrag(event) {
      this.dragging = true;
      this.dragOffset.x = event.clientX - this.position.x;
      this.dragOffset.y = event.clientY - this.position.y;
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
    },
    startDragTouch(event) {
      const touch = event.touches[0];
      if (!touch) {
        return;
      }
      this.dragging = true;
      this.dragOffset.x = touch.clientX - this.position.x;
      this.dragOffset.y = touch.clientY - this.position.y;
      window.addEventListener("touchmove", this.onDragTouch, {
        passive: false,
      });
      window.addEventListener("touchend", this.stopDrag);
    },
    onDrag(event) {
      if (!this.dragging) {
        return;
      }
      this.updatePosition(event.clientX, event.clientY);
    },
    onDragTouch(event) {
      if (!this.dragging) {
        return;
      }
      event.preventDefault();
      const touch = event.touches[0];
      if (!touch) {
        return;
      }
      this.updatePosition(touch.clientX, touch.clientY);
    },
    updatePosition(clientX, clientY) {
      const panel = this.$refs.panel;
      const width = panel ? panel.offsetWidth : 240;
      const height = panel ? panel.offsetHeight : 90;
      const nextX = clientX - this.dragOffset.x;
      const nextY = clientY - this.dragOffset.y;

      this.position.x = Math.min(
        Math.max(0, nextX),
        Math.max(0, window.innerWidth - width)
      );
      this.position.y = Math.min(
        Math.max(0, nextY),
        Math.max(0, window.innerHeight - height)
      );
    },
    stopDrag() {
      this.dragging = false;
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDragTouch);
      window.removeEventListener("touchend", this.stopDrag);
    },
  },
};
</script>

<style scoped>
.systemInfo {
  position: fixed;
  z-index: 2147483647;
  min-width: 170px;
  background-color: #c52222;
  border: 1px solid #8d1111;
  border-radius: 0.4rem;
  color: white;
  text-align: center;
  font-size: 1rem;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);
  user-select: none;
}

.systemInfo-drag {
  cursor: move;
  background: rgba(0, 0, 0, 0.22);
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 0.2rem 0.5rem;
}

.systemInfo-body {
  padding: 0.45rem 0.7rem 0.55rem;
}
</style>
